<template>
	<div>
		<NavHeader />


		<div class="main-header-content">
			<div class="container">
				<h3>Business Payments Terms & Conditions</h3>
			</div>
		</div>

		<div class="divider"></div>


		<div class="container">
			<div class="information-detail">
				<privacy-sidebar />

				<div class="information-content">
					<h6 class="info-header">E-REMIT USER AGREEMENT</h6>
					<h6 class="info-header">(Applicable for Users who are Companies / Sole-Proprietorships / Partnerships /
						Associations)</h6>


					<p class="content-para">
						THE USE OF MERCHANTRADE ASIA SDN BHD (Company No: 410591-T) (MERCHANTRADE)’S e-Remit BUSINESS SERVICES ARE
						SUBJECT TO THIS E-REMIT USER AGREEMENT (‘THIS AGREEMENT’) WHICH DESCRIBES THE RIGHTS AND OBLIGATIONS OF THE USER
						AND MERCHANTRADE’S RIGHTS AND OBLIGATIONS. PLEASE READ THIS AGREEMENT CAREFULLY. BY REQUESTING AND/OR USING THIS
						e-Remit BUSINESS SERVICES, YOU ACKNOWLEDGE TO HAVE READ, UNDERSTOOD AND AGREE TO BE BOUND BY THE TERMS AND
						CONDITIONS OF THIS AGREEMENT.
					</p>
					<div class="business-tnc-list">
						<ol>
							<li>DEFINITIONS & INTERPRETATIONS
								<ol>
									<li>
										<p class="content-para"><strong>"Applicable Laws"</strong> means the laws, regulations, policies, guidelines,
											rules and
											requirements (whether or not having the force of law) in the relevant jurisdiction governing Merchantrade
											and/or the User (as may be applicable), including but without limitation to Anti-Money Laundering,
											Anti-Terrorism Financing and Proceeds of Unlawful Activities Act 2001, Money Services Business Act 2011,
											Personal Data Protection Act 2010 and shall include such other requirements that Merchantrade stipulates
											from time to time.</p>
									</li>
									<li>
										<p class="content-para">"Authorised Person"</strong> means employees or any individual(s) authorised by the
											User to
											access and use the e-Remit Business System and its services on behalf of the User and to provide
											Merchantrade with settlement and delivery instructions for all Transactions.</p>
									</li>
									<li>
										<p class="content-para"><strong>"Business day"</strong> means any day on which both the banks in Malaysia and
											Beneficiary
											Country are open for business and is subject always to FPX services availability. </p>
									</li>
									<li>
										<p class="content-para"><strong>"Beneficiary"</strong> means the beneficiary who ultimately receives the
											payment in accordance
											to the User’s instruction through the e-Remit Business System. </p>
									</li>
									<li>
										<p class="content-para"><strong>"Beneficiary Account"</strong> means the bank account of the Beneficiary
											authorized by the
											User for the purpose of money transfer/remittance payout.</p>
									</li>
									<li>
										<p class="content-para"><strong>"Beneficiary Bank"</strong> means the bank located at the Beneficiary’s
											Country at which the
											Beneficiary maintains an Account for the purpose of crediting the remittance payout.</p>
									</li>
									<li>
										<p class="content-para"><strong>"Beneficiary Country"</strong> means the country of the Beneficiary where the
											crediting of the
											Beneficiary’s account is to be made.</p>
									</li>
									<li>
										<p class="content-para"><strong>"Beneficiary Currency"</strong> means the currency in which the remittance
											payout is to be
											made.</p>
									</li>
									<li>
										<p class="content-para"><strong>"Direct Deposit"</strong> means a mode of remittance payout via e-Remit
											Business System
											whereby the Beneficiary’s Designated Bank Account maintained at the Beneficiary’s Country is directly
											credited with the remittance amount in accordance to the User’s payout instruction.</p>
									</li>
									<li>
										<p class="content-para"><strong>"e-Remit Business Services"</strong> or <strong>"Services"</strong> refers to
											an online money transfer service
											offered by Merchantrade to facilitate User’s transfer of funds for the sole purpose of payment for purchase
											/ utilization by the User of goods and services to overseas suppliers / service providers / individuals.</p>
									</li>
									<li>
										<p class="content-para"><strong>"e-Remit Business System"</strong> or <strong>"System"</strong> means
											Merchantrade’s proprietary online
											remittance / money transfer system accessible by the User via Website or mobile device or such other
											electronic devices which are capable of supporting the e-Remit Business Services application for purposes of
											carrying out the Transaction. </p>
									</li>
									<li>
										<p class="content-para"><strong>"FPX"</strong> refers to Financial Processing Exchange, a national online
											payment gateway
											which is jointly developed by Financial Institutions and is owned by MEPS.</p>
									</li>
									<li>
										<p class="content-para"><strong>"Loss"</strong> includes loss, damage, claim, costs, subscription fees,
											charges, damages and /
											or expenses of whatsoever nature without limitation arising from contract, tort, equity or any other
											principles of law or legal theory (including any loss of profits, lost of savings, loss of data, loss of
											opportunity, loss of goodwill, special, incidental, punitive or exemplary losses and consequential damages)
											and howsoever arising whether direct, indirect, joint, several, actual, contingent or otherwise (including
											legal fees on a full indemnity basis), and includes without limitation claims made by third parties and
											claims for defamation, infringement of intellectual property rights, death, bodily injury, wrongful use of
											computers and unauthorized or illegal access to computers (including but not limited to hacking), property
											damage or pecuniary losses howsoever arising. </p>
									</li>
									<li>
										<p class="content-para"><strong>"Merchantrade"</strong> refers to Merchantrade Asia Sdn Bhd (Company No.
											410591-T), a company
											incorporated under the laws of Malaysia with its corporate office at Suite 1632, 16th Floor, Block A,
											Damansara Intan, No. 1 Jalan SS20/27, 47400 Petaling Jaya , Selangor Darul Ehsan and includes its successors
											and assigns.</p>
									</li>
									<li>
										<p class="content-para"><strong>"Net Payout Amount"</strong> means the net amount to be credited to the
											Beneficiary’s Account
											in the currency of the Beneficiary’s country.</p>
									</li>
									<li>
										<p class="content-para"><strong>"Privacy Notice"</strong> means Merchantrade’s policies and principles
											pertaining to the
											collection, use and storage of personal information of the User as may be amended from time to time and made
											available at <a href="javascript:void(0)">www.eremit.com.my</a> </p>
									</li>
									<li>
										<p class="content-para"><strong>"Password"</strong> means an alpha-numeric access code with at least one (1)
											special
											character opted by the User’s authorised persons for the purpose of gaining access to the e-remit for
											Business System</p> to: 
										<ol>
											<li>
												<p class="content-para">access the User’s Account to carry out money transfer transaction.</p>
											</li>
											<li>
												<p class="content-para">initiate change in address, view previous transaction records and ascertain status
													of current transaction. </p>
											</li>
											<li>
												<p class="content-para">perform such other acts as permitted by the e-Remit Business System from time to
													time</p>
											</li>
										</ol>
									</li>
									<li>
										<p class="content-para"><strong>"Rate Table"</strong> means a table of Foreign Exchange rate where the
											conversion rate of each
											payout currencies are displayed and is subject to change from time to time according to the prevailing
											market condition. </p>
									</li>
									<li>
										<p class="content-para"><strong>"Service Charge"</strong> means fee imposed by Merchantrade to the User for
											each remittance
											instruction made and is subject to change at Merchantrade’s sole and absolute discretion. </p>
									</li>
									<li>
										<p class="content-para"><strong>"Terms of Services"</strong> or <strong>"these Terms"</strong> means all the
											terms and conditions under which
											the Services is offered by Merchantrade to the User. </p>
									</li>
									<li>
										<p class="content-para"><strong>"Transaction"</strong> means online remittance or money transfer transaction
											carried out by
											the User through the e-Remit Business System. </p>
									</li>
									<li>
										<p class="content-para"><strong>"Taxation Authority"</strong> means any government, state or municipility or
											any local, state,
											federal or other authority, body of official exercising a fiscal, revenue or exice function. </p>
									</li>
									<li>
										<p class="content-para"><strong>"Taxes"</strong> means any tax, levy, duty, charge, deduction and witholding
											(without
											limitation goods and service tax (GST), if applicable) , however it is described as that is imposed under
											the Applicable Laws by the Taxation Authority with any related interest, penalty, fine or other charges.</p>
									</li>
									<li>
										<p class="content-para"><strong>"User/You/Your"</strong> means Company / Sole-Proprietorship / Partnership /
											Association whose
											application for Services has been accepted and registered with Merchantrade. </p>
									</li>
									<li>
										<p class="content-para"><strong>"User’s Account"</strong> refers to the facility provided to the User upon
											registration for
											uniquely identifying the User of the Services and for accessing the Services. </p>
									</li>
									<li>
										<p class="content-para"><strong>"Website"</strong> means Merchantrade’s designated website: <a href="javascript:void(0)">www.eremit.com.my</a>
											which is open to
											access by Users. </p>
									</li>
									<li>
										<p class="content-para">Unless repugnant to the context herein in these terms:-</p>
										<ol>
											<li>
												<p class="content-para">reference to a particular gender shall be deemed to include a reference to the
													other gender.</p>
											</li>
											<li>
												<p class="content-para"></p>reference to singular shall include the plural vice versa.
											</li>
											<li>
												<p class="content-para"></p>reference to word <strong>"include"</strong> or <strong>"including"</strong>,
												wherever appearing in these Terms
												shall be read as if the word <strong>"without limitation"</strong> inserted thereafter. 
											</li>
										</ol>
									</li>
								</ol>
							</li>
							<p class="content-para">
								THE USER HEREBY AGREES TO SUBSCRIBE TO THESE SERVICES UPON THE TERMS HEREIN CONTAINED.
							</p>
							<li>
								ELIGIBILITY
								<ol>
									<li>
										<p class="content-para">The User shall be a registered entity under the Companies Commission of Malaysia and
											is elligible to apply and use the e-Remit Business System. </p>
									</li>
									<li>
										<p class="content-para">User must meet the Customer Due Diligence requirements imposed by Merchantrade and
											Applicable Laws.</p>
									</li>
									<li>
										<p class="content-para">A visitor who accesses the Website or avail the Services acknowledges that he may be
											violating the Applicable Laws and agrees to be solely and absolutely liable for any liabilities arising
											therefrom and undertakes to indemnify Merchantrade against any Loss incurred by Merchantrade thereto.</p>
									</li>
								</ol>
							</li>
							<li>
								SERVICE CHARGE AND FOREIGN EXCHANGE RATE
								<ol>
									<li>
										<p class="content-para">For each remittance transaction through the e-Remit Business System, the User shall
											be liable for Service Charge. The applicable Service Charge and foreign exchange rate are based on the
											latest Rate Table provided by Merchantrade from time to time. The User agrees that Merchantrade shall have
											the absolute and sole discretion in determination of the said Service Charge and applicable foreign exchange
											rate. The latest Rate Table shall be applicable after being posted on <a href="javascript:void(0)">www.eremit.com.my</a>  </p>
									</li>

								</ol>
							</li>
							<li>
								USER’S RESPONSIBILITY
								<ol>
									<li>
										<p class="content-para">User warrants that all particulars and information provided by the User to facilitate
											approval and registration for the Services are true, accurate, current, complete and not misleading. The
											User further undertakes to forthwith notify Merchantrade of any changes to the User’s corporate particulars
											i.e shareholding and directorship structure and / or business activities and such other information as
											required by Merchantrade, in writing, by way of prepaid registered post, email and by producing original
											identification documents for verification purposes.</p>
									</li>
									<li>
										<p class="content-para">User undertakes to indemnify Merchantrade, its employees, directors, officers,
											representatives, affiliates, subsidiaries and agents for any Loss caused to Merchantrade arising from the
											User providing untrue, inaccurate, out-of-date, incomplete or misleading information or particulars.</p>
									</li>
									<li>
										<p class="content-para">User is responsible to ensure that its Authorised Person shall take all such measures
											and steps as may be necessary (including but not limited to changing User’s password from time to time) to
											protect User’s password and to prevent unauthorised use of User’s Account or disclosure of the User’s
											password. The User acknowledges that it is the Authorised Person’s sole and absolute responsibility to
											maintain secrecy and confidentiality of the User’s password and the Authorised Person shall be fully and
											absolutely liable for all transactions and activities that occur under the User’s username and password
											including unauthorized use and misuse. </p>
									</li>
									<li>
										<p class="content-para">User shall notify Merchantrade either in writing or by way of email through the
											User’s designated email, if the User becomes aware of or reasonably believe that there is any unauthorized
											use of the User’s Account or any other breach of security, and to co-operate with Merchantrade in all such
											investigation. This shall include (i) unauthorized usage of username and password (ii) receipt by User of
											any transaction confirmation, fund transfer or such activities that User did not authorize or (iii) any
											inaccurate information in User’s current transaction or transaction history.</p>
									</li>
									<li>
										<p class="content-para">User shall be responsible and liable for any third party gaining access to the
											e-Remit Business System through the use of the User’s username and password, and in such event, the User
											shall hold Merchantrade, its employees, directors, officers, representatives, affiliates, subsidiaries and
											agents harmless against any Loss arising from any such unauthorised access. Any transaction and/or activity
											arising from the usage of the User’s name and password will be deemed the User’s transaction and/or
											activities, and Merchantrade is under no obligation whatsoever to verify authenticity of such transactions
											and/or activity. </p>
									</li>
									<li>
										<p class="content-para">User is responsible to log out after each session of accessing e-Remit Business
											System. </p>
									</li>
									<li>
										<p class="content-para">User acknowledges and agrees that:-</p>
										<ol>
											<li>
												<p class="content-para">unless there are sufficient funds deposited with Merchantrade in advance for the
													amount requested to be remitted by the User inclusive of applicable Service Charge and Taxes, Merchantrade
													comes under no obligation whatsoever to act on the User’s payout instruction.</p>
											</li>
											<li>
												<p class="content-para">Merchantrade may restrict, decline or refuse User’s request for carrying out
													transaction at any time at Merchantrade’s sole discretion without assigning any reasons thereto. </p>
											</li>
											<li>
												<p class="content-para">although the Services may be accessible outside of Malaysia via the Website,
													Merchantrade accepts no liabilities whatsoever arising from any non-compliance with the laws of any
													country
													other than Malaysia for the use of the Services.</p>
											</li>
											<li>
												<p class="content-para">the User must specify in the relevant column/field provided in the e-Remit Business
													System, the source of remittance fund and purpose of the remittance/money transfer each time a transaction
													is conducted and to provide and upload supporting documents e.g. invoices issued by the Beneficiary.</p>
											</li>
											<li>
												<p class="content-para">Merchantrade may rely on the registration information and the remittance payout
													information provided by the User to Merchantrade. Any errors in the information provided by the User
													including misidentification of Beneficiary, incorrect account holder’s names and account numbers shall be
													at the User’s sole responsibility and risk. The User undertakes to hold Merchantrade harmless from all
													losses and damages arising from any Merchantrade’s act or omission in reliance upon any such erroneous
													information. </p>
											</li>
											<li>
												<p class="content-para">the User acknowledges that the duration for remittance payout delivery to the
													Beneficiary shall be as stipulated in the e-Remit Business System.</p>
											</li>
											<li>
												<p class="content-para">in the event the User cancels a Transaction or the Transaction is unsuccessful due
													to reasons of erroneous particulars provided by the User, the User shall remain liable for the applicable
													Service Charge and Taxes.</p>
											</li>
											<li>
												<p class="content-para">without limitation, the User acknowledges that it must maintain an internet banking
													facilities account with FPX participating bank(s) in Malaysia for the use of the Services.</p>
											</li>
											<li>
												<p class="content-para">FPX is a separate legal entity and use of FPX services is subject to terms,
													requirements and restrictions imposed by FPX and charges FPX imposes on the User. User shall ascertain and
													update itself of such applicable terms and conditions. Merchantrade is neither liable nor responsible for
													any Loss incurred by the User or any other person arising from the User’s utilisation of the FPX services.</p>
											</li>
											<li>
												<p class="content-para">for SWIFT transfer, the correspondent bank may deduct a handling fee where the
													Beneficiary may receive the transfer amount after deduction of the SWIFT charges.</p>
											</li>
											<li>
												<p class="content-para">Merchantrade reserves sole and absolute discretion to determine and impose limits
													for the transactions performed through the e-Remit Business System whether in amount, frequency or
													otherwise in accordance to the Applicable Laws and that Merchantrade reserves absolute rights to vary such
													limitations subject to requirements/amendments to the Applicable Laws and/or Merchantrade’s internal
													policies.</p>
											</li>
											<li>
												<p class="content-para">the Services is subject to Bank Negara Malaysia’s Cautionary Statement whereby BNM
													does not guarantee the remittance of funds by Merchantrade and User take the risk of any Loss suffered
													from
													remittance. A copy of the Cautionary Statement also known as Notice to Customers can be viewed at
													<a href="javascript:void(0)">www.eremit.com.my</a>. </p>
											</li>
										</ol>
									</li>
								</ol>
							</li>
							<li>
								PASSWORD
								<ol>
									<li>
										<p class="content-para">In the event the User has forgotten the dedicated password to access the System, the
											User:-</p>
										<ol>
											<li>
												<p class="content-para">shall log-in to <a href="javascript:void(0)">www.eremit.com.my</a> and click on “Forgot your password” to reset
													Password where
													the System will generate a temporary password which will be send to User’s designated email address. </p>
											</li>
											<li>
												<p class="content-para">acknowledges that issuance of a temporary password to its Authorised Person is at
													the sole
													and absolute discretion of Merchantrade and that Merchantrade may refuse / decline issuance of a temporary
													password
													without assigning any reason thereto. Merchantrade may without limitation require that User provide
													additional
													information or such documents to Merchantrade’s satisfaction prior to issuing the User’s Authorised Person
													with a
													temporary password.</p>
											</li>
											<li>
												<p class="content-para">acknowledges that upon a request to reset password, the User’s existing password
													will be
													invalidated and the User’s Authorised Person shall be required to create a new password by using the
													temporary
													password provided by Merchantrade. The Authorised Person shall not carry out Transaction with any
													temporary password
													provided by Merchantrade.</p>
											</li>
											<li>
												<p class="content-para">acknowledges and agree that the User’s Authorised Person will be subject to
													identity
													verification to Merchantrade’s satisfaction, Merchantrade will generate a temporary password which will be
													communicated to the User’s designated email address registered with Merchantrade. It is the User’s
													responsibility to
													ensure that the Authorised Person maintain the User’s email address. Upon receipt of the temporary
													password
													generated by Merchantrade, for security purposes, the User undertakes to change the password on an
													immediate basis.</p>
											</li>
										</ol>
									</li>

									<li>
										<p class="content-para">The User shall be fully responsible for all actions or omissions of the Authorised
											Person. </p>
									</li>

								</ol>


							</li>
							<li>
								PROHIBITIONS & RESTRICTIONS
								<ol>
									<li>
										<p class="content-para">User shall not:-</p>
										<ol>
											<li>
												<p class="content-para">use the Services in any way which will deprive other Users of their legitimate
													right to use the Services. </p>
											</li>
											<li>
												<p class="content-para">use the Website for unlawful purposes in any jurisdiction or in breach of these
													Terms. </p>
											</li>
											<li>
												<p class="content-para">use the Services for any unlawful or illegal activity or in breach of any
													Applicable Laws including without limitation and such subsequent amendments thereto.</p>
											</li>
											<li>
												<p class="content-para">modify, copy, distribute, reproduce, transmit, display, perform, publish, upload,
													post, license, create derivative works from, transfer or sell any information, designs, logos, trademarks,
													software or services obtained from the Website.</p>
											</li>
											<li>
												<p class="content-para">post or transmit any unlawful, fraudulent, libelous, defamatory, obscene,
													pornographic, profane, threatening, abusive, hateful, offensive, or otherwise objectionable information or
													statement of any kind without limitation, any information or statement constituting or encouraging conduct
													that would tantamount to criminal offence, give rise to civil liability and/or violates any Applicable
													Laws.</p>
											</li>
											<li>
												<p class="content-para">post or transmit any messages that amount to advertising material, touting or sale
													of, or offer to sell, any product or service.</p>
											</li>
											<li>
												<p class="content-para">transmit or disseminate advertising material, chain letters, spam, junk mail or
													other
													type of unsolicited messages. </p>
											</li>
											<li>
												<p class="content-para">post or transmit or disseminate viruses, worms, Trojan horses or other harmful,
													disruptive or destructive files.</p>
											</li>
											<li>
												<p class="content-para">post, publish, transmit, reproduce, distribute, or in any way exploit any
													information
													, software or other material obtained from or through the Website for commercial purposes.</p>
											</li>
											<li>
												<p class="content-para">attempt to decompile or reverse engineer any software available in the Website.</p>
											</li>
											<li>
												<p class="content-para">attempt to hack into the Website or otherwise attempt to subvert any firewall or
													other security measure of the Website.</p>
											</li>
											<li>
												<p class="content-para">allow access, re-sell or re-provide the Services to any other person. </p>
											</li>
										</ol>
									</li>
									<li>
										<p class="content-para">In the event, the Website contains bulletin boards, chat rooms, access to mailing
											lists or other communication facilities, the User shall only to send and receive messages that are proper
											and related to the particular subject forum/purposes only.</p>
									</li>
									<li>
										<p class="content-para">Any software provided on, by or through the Website for a specific purpose shall only
											be used for that purpose and no other. </p>
									</li>
									<li>
										<p class="content-para">User shall comply with the rules of any network through which User access the
											Services.</p>
									</li>
									<li>
										<p class="content-para">User shall comply with and shall not contravene Applicable Laws, without limitation
											laws of such jurisdiction relating to the use of the Services.</p>
									</li>
									<li>
										<p class="content-para">The Services is only available in Malaysia. If for any reason the User uses the
											Services outside Malaysia, Merchantrade may not support the Services and User’s use of the Services at the
											User’s own risk including the risk that the use thereof violates local laws in the country/jurisdiction. </p>
									</li>
									<li>
										<p class="content-para">User acknowledges and agrees that the Services without limitation and in addition to
											these Terms is subject to availability of FPX and such requirements, conditions and restrictions imposes on
											the User. Merchantrade shall not be liable to User or 3rd party for any acts or omissions of FPX. User
											undertakes to exercise due diligence to ascertain the terms of FPX services.</p>
									</li>

								</ol>
							</li>
							<li>
								LIMITATION OF LIABILITY

								<ol>
									<li>
										<p class="content-para">Merchantrade’s liablity to the User under this Term is strictly limited to the refund
											of the remittance amount transacted by the User through the Services (excluding charges, costs of expenses
											of whatsoever nature including FPX or bank charges the User may have incurred) which remains undelivered /
											unpaid to the Beneficiary, SUBJECT TO ALWAYS that such failure is not contributed by any act or ommission of
											the User. </p>
									</li>
									<li>
										<p class="content-para">Except for Merchantrade’s refund obligation under <strong>clause 7.1</strong>, under
											no circumstances Merchantrade will be liable for and Loss to the User whether or not such Loss is due to
											wilfull act, omission, neglect, default or non-performance on the part of Merchantrade, its directors,
											shareholders, employees or agents or such other person(s) / entity(ies) engaged by Merchantrade to
											facilitate the Services. </p>
									</li>
									<li>
										<p class="content-para">Subject to and without prejudice to clause <strong> 7.1</strong> and <strong> 7.2</strong>
											or any other provisions under this Terms to the contrary, Merchantrade’s cumulative liablity for all losses,
											claims, suits, controversies, breaches or damages for any cause whatsoever
											(including but not limited to those arising out of or related
											to this Agreement) and regardless of the form of action or legal theory <strong> SHALL NOT EXCEED RM100-00.</strong></p>
									</li>
									<li>
										<p class="content-para">Without limitation to <strong> clause 7 </strong>of these Terms, Merchantrade shall
											not be responsible or liable for any Loss incurred or suffered by the User or any third party arising from:-</p>
										<ol>
											<li>
												<p class="content-para">User’s inability to perform any transactions due to the limits set by Merchantrade
													from time to time; or</p>
											</li>
											<li>
												<p class="content-para">any intrusion or attack by any person or party on the hardware, software, the
													e-Remit Business System through internet, mobile, tablet devices and / or such other electronic devices
													(capable of supporting the Services application) including but not limited to viruses, Trojan Horses,
													malware and / or macros or other harmful componentsor disabling devices that may suspend, disrupt, or
													disbale the e-Remit Business System or any part thereof. </p>
											</li>
										</ol>
									</li>

								</ol>
							</li>
							<li>
								DISCLAIMER
								<ol>
									<li>
										<p class="content-para"></p>Due to the inherent hazards of electronic distribution, User agree and accept
										that Services may be unavailable from time to time due to required maintenance, electronic or other systems
										failures or interruptions (whether of Merchantrade or any third party) or other disruptions. Merchantrade,
										its suppliers and their respective affiliates, officers, distributors and employees shall not be liable to
										the User for any Loss suffered by the User as a result thereof. Merchantrade does not guarantee that Services
										will be uninterrupted, secure, error-free and free from viruses or other harmful components.
									</li>
									<li>
										<p class="content-para">Merchantrade cannot and does not endorse or review, and cannot be responsible for,
											the messages, views, opinions and recommendations of third parties, User and organisations of deemed
											interest. Merchantrade does not advocate any commercial dealings in any third party products or investments.
											The inclusion in Services of a link to other web site(s) or resources does not imply any form of endorsement
											by Merchantrade. Any User seeking recourse shall do so against such party providing such advice, products or
											services. However, Merchantrade requires all Users to comply with all relevant laws, as well as the rules
											set out in the Website, and ensure that the law and the rules are observed and complied with. Without
											limitation, User acknowledges that Merchantrade is not responsible for the privacy and confidentiality of
											any personal information provided by the User to the other linked websites in any manner whatsover. </p>
									</li>
									<li>
										<p class="content-para">Merchantrade reserves absolute discretion without notice to the User, to introduce
											changes to the features appearing in the Website from time to time without limitation to add, modify or
											remove such features. </p>
									</li>
									<li>
										<p class="content-para">In amplification to any provisions of these Terms, Merchantrade does not guarantee
											storage of any data stored by the User in the System and excludes all liability for loss of data. </p>
									</li>
								</ol>
							</li>
							<li>
								INDEMNITY
								<ol>
									<li>
										<p class="content-para">User shall indemnify Merchantrade, its directors, officers, its suppliers, their
											employees, subsidiaries, related corporation, associates, distributors and affiliates against any and all
											Loss suffered by Merchantrade, its directors, officers, its suppliers, their employees, subsidiaries,
											related corporation, associates, distributors and affiliates to any person as a result of any breach of
											these Terms without limitation to any acts or omission of the Authorised Person in breach of these Terms.</p>
									</li>

								</ol>
							</li>
							<li>
								NOTICES
								<ol>
									<li>
										<p class="content-para">All notices are deemed served on the User immediately after it is posted on the
											Website or sent to the User’s designated e-mail address (despite evidence to the contrary) as set out in the
											Registration Form or such e-mail address of which notice has been given to Merchantrade by the User in
											writing by way of prepaid registered post.</p>
									</li>
								</ol>
							</li>

							<li>FORCE MAJEURE
								<ol>
									<li>
										<p class="content-para">Merchantrade, its correspondent agents and / or any entities involved in the process
											of remittance transfer shall not be liable for any loss or damage arising from any delay or failure in the
											remittance transmission due to any government order, law, levy tax or exchange restriction or any other
											cause beyond the control of Merchantrade (including but not limited to Acts of God).</p>
									</li>
								</ol>
							</li>
							<li>ASSIGNMENT
								<ol>
									<li>
										<p class="content-para">This Agreement is not assignable by the User.</p>
									</li>
								</ol>
							</li>
							<li>THIRD PARTY
								<ol>
									<li>
										<p class="content-para">Nothing in this Terms confers or shall purport to confer on any third party any
											benefit or any right to enforce any terms or conditions herein.</p>
									</li>

								</ol>
							</li>
							<li>JURISDICTION & GOVERNING LAWS
								<ol>
									<li>
										<p class="content-para">The terms and conditions herein and all remittance transactions by way of e-Remit
											Business Services shall be governed and interpreted according to the laws of Malaysia and subject to the
											exclusive jurisdiction of the Courts of Malaysia. </p>
									</li>
									<li>
										<p class="content-para">These Terms between Merchantrade and the User shall be deemed to have been made and
											executed at Merchantrade’s office in Petaling Jaya and any breach of the terms and conditions stated herein
											shall be deemed to have arisen in Petaling Jaya irrespective of where the User carries out business or where
											the Transaction may have taken place.</p>
									</li>

								</ol>
							</li>
							<li>DISCLOSURE
								<ol>
									<li>
										<p class="content-para">The User hereby agrees that Merchantrade’s rights to the User’s and Beneficiary(ies)
											information and disclosure shall be in accordance with Merchantrade’s Privacy Notice. User further consents
											to holding, collection and use of all personal data provided by the User arising from the Services in
											accordance with the Privacy Notice as may be amended from time to time.</p>
									</li>
									<li>
										<p class="content-para">In amplification and not in derogation of <strong>clause 15.1</strong> above of these
											Terms, Merchantrade reserves the right to disclose part of or all information concerning the User and / or
											Beneficiary(ies) at such time and in such manner as is permitted or required by the Applicable Laws to the
											relevant authorities. </p>
									</li>

								</ol>
							</li>
							<li>TIME & NON-WAIVER
								<ol>
									<li>
										<p class="content-para">Time wherever mentioned shall be the essence of these Terms and no failure to
											exercise and delay in exercising on the part of Merchantrade of any right, power or privilege under these
											Terms shall operate as a waiver thereof, nor shall any single or partial exercise of any right, power or
											privilege preclude any other or further exercise thereof or the exercise of any other right, power or
											privilege. The rights and remedies herein provided are cumulative and not exclusive of any rights or
											remedies provided by law.</p>
									</li>
								</ol>
							</li>
							<li>EXCHANGE RATE
								<ol>
									<li>
										<p class="content-para">The conversion of exchange rate are based on the latest Rate Table provided by
											Merchantrade and are subject to change without prior notice at Merchantrade’s sole and absolute discretion.
										</p>
									</li>
								</ol>
							</li>
							<li>SEVERALIBILITY
								<ol>
									<li>
										<p class="content-para">If any provision in these Terms is found or held to be invalid or unenforceable, then
											the meaning of such provision shall be construed to the fullest extent allowed by law so as to render the
											provision valid and enforceable, and if no such constrain is possible, the invalidity or unenforceability of
											such provision shall not effect the other provisions of these Terms.</p>
									</li>
								</ol>
							</li>
							<li>REGULATORY
								<ol>
									<li>
										<p class="content-para">The User acknowledges that e-Remit Business Services shall be subject to the
											applicable rules, guidelines and requirements of Bank Negara Malaysia.</p>
									</li>
								</ol>

							</li>
							<li>AMENDMENTS
								<ol>

									<li>
										<p class="content-para">Merchantrade reserves the right to vary, alter and amend any or all of these Terms
											herein and announce changes to its Services and to post them on <a href="javascript:void(0)">www.eremit.com.my</a>. User’s continued use of
											the Services offered by Merchantrade after such variation, alteration and amendments have been posted
											constitutes User’s agreement to be bound by them. The User shall have no recourse whatsoever against
											Merchantrade for any Loss as a result of such variation, alteration, amendment or otherwise.</p>
									</li>
									<li>
										<p class="content-para">No rule of construction applies to the disadvantage of Merchantrade as Merchantrade
											was responsible for the preparation of this Agreement or any part of it.</p>
									</li>
								</ol>
							</li>
							<li>
								ENGLISH VERSION
								<ol>
									<li>
										<p class="content-para">In the event these Terms are translated into a language other than English, it is
											done solely for convenience purpose, with only the English version of these Terms shall be valid and
											binding.</p>
									</li>
								</ol>
							</li>
							<li>DISCREPANCY AND CONFLICT
								<ol>
									<li>
										<p class="content-para">In the event there is conflict or discrepancy between any of the provisions of these
											Terms and such other terms appearing elsewhere in the Website, the Terms to the extent of such discrepancies
											and / or conflict shall take priority and precedence for all intents and purposes.</p>
									</li>
								</ol>
							</li>
							<li>SURVIVAL
								<ol>
									<li>
										<p class="content-para">The obligations and responsibilities of the User under these Terms by their nature
											should survive termination shall so survive. </p>
									</li>
								</ol>
							</li>
							<li>TITLE AND HEADINGS
								<ol>
									<li>
										<p class="content-para">The title and headings of clauses of these Terms are solely for convenience of
											reference and will not be used in interpreting or construing the Terms.</p>
									</li>

								</ol>
							</li>
						</ol>

					</div>


					<!-- 
					<p class="content-para">PLEASE READ THIS AGREEMENT CAREFULLY. BY REQUESTING AND/OR USING THIS e-remit SERVICES YOU
						AGREE TO BE BOUND BY THE
						TERMS AND CONDITIONS OF THIS AGREEMENT AS FOLLOWS:-</p>
					<p class="content-para">1. DEFINITIONS AND INTERPRETATIONS</p>
					<p class="content-para">1.1
						<strong>"Applicable Laws and Requirements"</strong> means the laws, regulations, policies, guidelines, rules and
						requirements
						(whether or not having the force of law) in the relevant jurisdiction governing MTASB and/or the User (as may be
						applicable),
						including but without limitation to anti-money laundering and anti-terrorism laws, and laws pertaining to money
						transfer
						services.</p>

					<p class="content-para">1.2
						<strong>"Business day"</strong> means any day on which both the banks in Malaysia and Recipient Country are open
						for business
						and subject always to FPX services availability.</p>

					<p class="content-para">1.3
						<strong>"Direct Deposit"</strong> means a mode of remittance payout via e-remit System whereby the Recipient's
						Designated Bank
						Account maintained at the Recipient's Country is directly credited with the remittance amount in accordance to
						the
						User's payout instruction.</p>

					<p class="content-para">1.4
						<strong>"e-remit or e-remit Services or Services"</strong> refers to an online money transfer services offered by
						MTASB to
						facilitates User's money transfer authorization to be paid in the currency of the Recipient's Country.</p>
					<p class="content-para">1.5
						<strong>"e-remit System"</strong> means MTASB's proprietary online remittance/ money transfer system accessible
						by the User
						via the Website for the purposes of carrying out money transfer Transaction</p>
					<p class="content-para">1.6
						<strong>"FPX"</strong> refers to Financial Processing Exchange a national online payment gateway which is jointly
						developed
						by Financial Institutions and is owned by MEPS.</p>

					<p class="content-para">1.7
						<strong>"Loss"</strong> includes loss, damage, claim, costs, subscription fees , charges, damages and/or expenses
						of whatsoever
						nature without limitation arising from contract , tort, equity or any other principles of law or legal theory
						(including
						any loss of profits , lost savings, loss of data, loss of opportunity, loss of goodwill , special, incidental,
						punitive
						or exemplary losses and consequential damages ) and howsoever arising whether direct , indirect , joint ,
						several,
						actual, contingent or otherwise (including legal fees on a full indemnity basis) , and includes without
						limitation
						claims made by third parties and claims for defamation , infringement of intellectual property rights, death,
						bodily
						injury, wrongful use of computers and unauthorized or illegal access to computers (including but not limited to
						hacking),
						property damage or pecuniary losses howsoever arising.</p>
					<p class="content-para">1.8
						<strong>"MTASB"</strong> refers to Merchantrade Asia Sdn Bhd, a company incorporated under the laws of Malaysia
						with a corporate
						office at Suite 1632, 16th Floor, Block A, Damansara Intan, No. 1 Jalan SS20/27, 47400 Petaling Jaya , Selangor
						Darul
						Ehsan and includes its successors and assigns.</p>

					<p class="content-para">1.9
						<strong>"Non-resident"</strong> refers collectively to citizens and residents of countries other than Malaysia.</p>
					<p class="content-para">1.10
						<strong>"Password"</strong> means an alpha-numeric access code with at least one (1) special character opted by
						the User for
						the purpose of gaining access to the e-remit System to:
						<ul>
							<li>access the User's Account to carry out money transfer transaction.</li>
							<li>initiate change in address, view previous transaction records and ascertain status of current transaction.</li>
							<li>perform such other acts as permitted by the e-remit System from time to time.</li>
						</ul>
					</p>
					<p class="content-para">1.11
						<strong>"Recipient"</strong> means the beneficiary who ultimately receives the payment in accordance to the User
						instruction
						through the e-remit System.</p>
					<p class="content-para">1.12
						<strong>"Recipient Account"</strong> means the bank account of the Recipient authorized by the User for the
						purpose of money
						transfer/remittance payout.</p>
					<p class="content-para">1.13
						<strong>"Recipient Bank"</strong> means the bank located at the Recipient Country at which the Recipient
						maintains a Recipient
						Account for the purpose of crediting the remittance payout.</p>
					<p class="content-para">1.14
						<strong>"Recipient Country"</strong> means the country of the Recipient where the crediting of the Recipient's
						account is to
						be made.</p>
					<p class="content-para">1.15
						<strong>"Recipient Currency"</strong> means the currency in which the remittance payout is to be made.</p>
					<p class="content-para">1.16
						<strong>"Net Payout Amount"</strong> means the net amount to be credited to the Recipient's Account in the
						Recipient Currency.</p>
					<p class="content-para">1.17
						<strong>"Rate Table"</strong> means a table of Foreign Exchange rate where the conversion rate of each payout
						currencies are
						displayed and is subject to change from time to time according to the prevailing market condition.</p>
					<p class="content-para">1.18
						<strong>"Service Charge"</strong> means fee imposed by MTASB to the User for each remittance instruction made and
						is subject
						to change at MTASB discretion.</p>
					<p class="content-para">1.19
						<strong>"Terms of Service(or "these Terms")"</strong> means all the terms and conditions under which the Services
						is offered
						by MTASB to the User.</p>
					<p class="content-para">1.20
						<strong>"Transaction"</strong> means online remittance or money transfer transaction carried out by the User
						through the e-remit
						System.</p>
					<p class="content-para">1.21
						<strong>"User/Member/You/Your"</strong> means a person (excluding a firm, a body corporate or unincorporated
						association, Public
						Authority, two or more persons having a joint common interest, any other legal or commercial entity or
						undertaking)
						whose application for Services has been accepted and registered with MTASB.</p>
					<p class="content-para">1.22
						<strong>"User's Account or Member's Account"</strong> refers to the facility provided to the User upon
						registration for uniquely
						identifying the User of the Services and for accessing the Services.</p>
					<p class="content-para">1.23
						<strong>"Visitor"</strong> means any individual who is not a User that accesses the Website.</p>
					<p class="content-para">1.24
						<strong>"Website"</strong> means MTASB's designated website: www.eremit.com.my which is open to access by Users.</p>
					<p class="content-para">1.25 Unless repugnant to the context herein in these Terms :-
						<ul>
							<li>reference to a particular gender shall be deemed to include a reference to the other gender.</li>
							<li>reference to singular shall include the plural vice versa.</li>
							<li>reference to word "include" or "including", wherever appearing in these Terms shall be read as if the word
								"without
								limitation" inserted thereafter.</li>
						</ul>
						The User hereby agrees to subscribe to the Services upon these Terms herein contained.
					</p>
					<p class="content-para">2. ELIGIBILITY</p>
					<p class="content-para">2.1 User must have attained 18 years of age and permitted under the Applicable Laws or
						Requirements to enter into legally
						binding agreement.</p>
					<p class="content-para">2.2 A non-resident Visitor or User, who accesses the Website and/or avail the Services
						acknowledges that they may be
						violating the Applicable Laws and Requirements and agrees to be solely and absolutely liable for any liabilities
						arising
						therefrom and undertakes to indemnify MTASB against any Loss incurred by MTASB pursuant thereto.</p>

					<p class="content-para">3. SERVICE CHARGE AND FOREIGN EXCHANGE</p>
					<p class="content-para">For each remittance transaction through the e-remit System, the User shall be liable for
						Service Charge (‘SC'). The
						applicable Service Charge and foreign exchange rate are based on the latest Rate Table provided by MTASB from
						time
						to time. The User agrees that MTASB shall have the absolute and sole discretion in determination of the said SC
						and
						applicable foreign exchange rate. Latest rate tables shall be applicable immediately after posting on
						<a href="www.eremit.com.my">www.eremit.com.my</a>
					</p>

					<p class="content-para">4. USER'S RESPONSIBILITIES</p>
					<p class="content-para">4.1 User warrants that all particulars and information provided to facilitate approval and
						registration for Services
						are true, accurate, current, complete and not misleading and the User undertakes to forthwith notify MTASB of any
						changes
						to the User's supplied personal particulars, in writing, by way of prepaid registered post or by producing
						original
						identification documents for verification at any of MTASB remittance branch.</p>
					<p class="content-para">4.2 User undertakes to indemnify MTASB, its employees, directors, officers,
						representatives, affiliates, subsidiaries
						and agents for any Loss caused to MTASB arising from the User providing untrue, inaccurate, out-of-date,
						incomplete
						or misleading information or particulars.</p>
					<p class="content-para">4.3 User shall take all such measures and steps as may be necessary (including but not
						limited to changing User's password
						from time to time) to protect User's password and to prevent unauthorized use of User's Account or unauthorized
						disclosure
						of User's password. User acknowledges that it is his/her sole and absolute responsibility to maintain secrecy and
						confidentiality
						of his /her password and the User shall be fully and absolutely liable for all transactions and activities that
						occur
						under the User's username and password including unauthorized use and misuse.</p>
					<p class="content-para">4.4 User shall notify MTASB either in writing or by way of email through the User's
						designated email, if the User becomes
						aware of or reasonably believe that there is any unauthorized use of the User's Account or any other breach of
						security,
						and to co-operate with MTASB in all such investigation. This shall include (i) unauthorized usage of username and
						password
						(ii) receipt by User of any transaction confirmation, fund transfer or such activities that User did not
						authorize
						or (iii) any inaccurate information in User's current transaction or transaction history.</p>
					<p class="content-para">4.5 User shall be responsible and liable for any third party gaining access to the e-remit
						System through the use of
						the User's username and password, and in such event, the User shall hold MTASB, its employees, directors,
						officers,
						representatives, affiliates, subsidiaries and agents harmless against any Loss arising from any such
						unauthourised
						access. Any transaction and/or activity arising from usage of your username and password will be deemed the
						User's
						transaction and/or activities, and MTASB is under no obligation whatsoever to verify authenticity of such
						transactions
						and/or activity.</p>
					<p class="content-para">4.6 User shall ensure to log out after each session of accessing e-remit System.</p>
					<p class="content-para">4.7 User acknowledge and agrees as follows :-
						<ol type="a">
							<li>that unless there are sufficient funds deposited with MTASB in advance for the amount requested to be
								remitted by
								the Remitter inclusive of applicable Service Charge, MTASB comes under no obligation whatsoever to act on the
								User's
								payout instruction.</li>
							<li>that MTASB may restrict, decline or refuse User's request for carrying out transaction at any time at
								MTASB's sole
								discretion without assigning any reasons thereto.</li>
							<li>that although the Services may be accessible outside of Malaysia via the Website , MTASB accepts no
								liabilities whatsoever
								arising from any non-compliance with the laws of any country other than Malaysia for the use of the Services.</li>
							<li>that the User must specify in the relevant column/field provided in the e-remit System , the source of
								remittance
								fund and purpose of the remittance / money transfer each time a transaction is conducted.</li>
							<li>that MTASB may rely on the registration information and the remittance payout information provided by the
								User to
								MTASB. Any errors in the information provided by the User including misidentification of Recipient, incorrect
								account
								holder's names and account numbers shall be at the User's sole responsibility and risk. The User undertakes to
								hold
								MTASB harmless from all losses and damages arising from any MTASB's act or omission in reliance upon any such
								erroneous
								information.</li>
							<li>that the User acknowledges that the duration for remittance payout delivery to the Recipient shall be as
								stipulated
								in the e-remit system.</li>
							<li>that in the event the User's cancels a Transaction or the Transaction is unsuccessful due to reason
								erroneous particulars
								provided by the Sender , the User shall remain liable for Service Charge.</li>
							<li>that without limitation, the User acknowledges that he/she must maintain an internet banking facilities
								account with
								FPX participating local bank(s) in Malaysia to use this Service.</li>
							<li>that all charges imposed by FPX pursuant to any Transaction initiated by the User pursuant to or incidental
								to these
								Terms shall be borne by User.</li>
							<li>that FPX is a separate legal entity and use of FPX services is subject to terms and conditions imposed by
								FPX. User
								shall ascertain and update himself/herself of such applicable terms and conditions. MTASB and MoneyGram
								Payments
								Systems, Inc. are neither liable nor responsible for any Loss incurred by the User or any other person arising
								from
								the User's use of the FPX services.</li>
							<li>that for over the counter payout to Recipient, MTASB's payout timeline is on best effort basis whereby the
								payout
								to Recipient shall be made in accordance with the User's transaction instruction as soon as reasonably possible
								during
								the working hours at the Recipient's designated payout location.</li>
							<li>that e-remit services is subject to Bank Negara Malaysia (BNM) 's Cautionary Statement whereby BNM does not
								guarantee
								the remittance of the funds by MTASB and you take the risk of any Loss suffered from remittance. A copy of the
								Cautionary
								Statement also know as Notice to Customers can be viewed at
								<a href="www.eremit.com.my">www.eremit.com.my</a>
							</li>
						</ol>
					</p>
					<p class="content-para">5. PASSWORD</p>
					<p class="content-para">5.1 In the event where the User has forgotten his/her password, the User :-
						<ol type="a">
							<li>shall log-in to website: www.eremit.com.my and click on the box marked “Click Here To Reset Password” upon
								which e-remit
								System will generate a temporary password which will be send to User’s designated email address.</li>
							<li>acknowledges that issuance of a temporary password to the User is the sole and absolute discretion of MTASB
								and that
								MTASB may refuse/decline issuance of a temporary password without assigning any reason thereto. MTASB without
								limitation
								may require that User provide additional information or such documents to MTASB’s satisfaction prior to issuing
								the
								User with a temporary password.</li>
							<li>acknowledges that upon a request to reset password the User’s existing password will be invalidated and the
								User shall
								be required to create a new password using the temporary password provided by MTASB. User cannot carry out
								Transaction
								with any temporary password provided by MTASB.</li>
							<li>acknowledges and agree that the User will be subject to identity verification to MTASB’s satisfaction, MTASB
								will
								generate a temporary password which will be communicated to the User’s designated email address registered with
								MTASB.
								It will be the User’s sole responsibility to maintain this email address. Upon receipt of the temporary
								password
								generated by MTASB, for security purposes, the User undertakes to change the password on immediate basis.
								Notwithstanding,
								the User will remain responsible and liable for all transaction carried out up to the period the old password
								is
								discontinued.</li>
						</ol>
					</p>
					<p class="content-para">6. PROHIBITIONS AND RESTRICTIONS</p>
					<p class="content-para">6.1 User CANNOT :
						<ol type="a">
							<li>use the Services in any way which will deprive other Users of their legitimate right to use the Services.</li>
							<li>use the Website for unlawful purposes in any jurisdiction or in breach of these Terms.</li>
							<li>use the Services for any unlawful or illegal activity or in breach of any Applicable Laws and Requirements
								including
								without limitation the ANTI-MONEY LAUNDERING AND ANTI-TERRORISM FINANCING ACT 2001 and such subsequent
								amendments
								thereto.</li>
							<li>allow access, re-sell or re-provide the Services to any other person.</li>
							<li>modify, copy, distribute, reproduce, transmit, display, perform, publish, upload, post, license, create
								derivative
								works from, transfer or sell any information, designs, logos, trademarks, software or services obtained from
								the
								Website.</li>
							<li>post or transmit any unlawful, fraudulent, libelous, defamatory, obscene, pornographic, profane,
								threatening, abusive,
								hateful, offensive, or otherwise objectionable information or statement of any kind without limitation, any
								information
								or statement constituting or encouraging conduct that would tantamount to criminal offence, give rise to civil
								liability
								and/or violates any Applicable Laws & Requirements.</li>
							<li>post or transmit any messages that amount to advertising material, touting or sale of , or offer to sell,
								any product
								or service.</li>
							<li>transmit or disseminate advertising material, chain letters, spam, junk mail or other type of unsolicited
								messages.</li>
							<li>post or transmit or disseminate viruses, worms, Trojan horses or other harmful , disruptive or destructive
								files.</li>
							<li>post, publish, transmit, reproduce, distribute, or in any way exploit any information , software or other
								material
								obtained from or through the Website for commercial purposes.</li>
							<li>attempt to decompile or reverse engineer any software available in the Website.</li>
							<li>attempt to hack into the Website or otherwise attempt to subvert any firewall or other security measure of
								the Website.</li>
						</ol>
					</p>
					<p class="content-para">7. LIMITATION OF LIABILITY</p>
					<p class="content-para">7.1 Save and except for the User’s entitlement for full refund of remittance amount
						transacted by the User through the
						Services which remains undelivered/unpaid to the Recipient limited strictly due to MTASB’s sole willful act,
						omission,
						fraudulent misrepresentation, fraud and/or dishonesty. In no event MTASB, its employees, directors, shareholders,
						officers,
						representatives, affiliates, subsidiaries and agents shall be lilable without limitation for any Loss incurred by
						the
						User or any 3rd party arising from the Services whether nor not MTASB has been notified in advance of the
						possibility
						of such loss or damages.</p>
					<p class="content-para">7.2 Subject to Clause 7.1 , in no event shall MTASB’s aggregate liability to the User for
						any claims under or pursuant
						to these Terms shall exceed RM100-00. (Ringgit Malaysia : One Hundred Only).</p>
					<p class="content-para">8. DISCLAIMER</p>
					<p class="content-para">8.1 Due to the inherent hazards of electronic distribution, User agree and accept that
						Services may be unavailable from
						time to time due to required maintenance, electronic or other systems failures or interruptions (whether of MTASB
						or
						any third party) or other disruptions. MTASB, its suppliers and their respective affiliates, officers,
						distributors
						and employees shall not be liable to the User for any Loss suffered by the User as a result thereof. MTASB does
						not
						guarantee that Services will be uninterrupted, secure, error-free, free from viruses or other harmful components.</p>
					<p class="content-para">8.2 MTA cannot and does not endorse or review, and cannot be responsible for, the
						messages, views, opinions and recommendations
						of third parties, User and organisations of deemed interest. MTASB does not advocate any commercial dealings in
						any
						third party products or investments. The inclusion in Services of a link to other web site(s) or resources does
						not
						imply any form of endorsement by MTASB. Any User seeking recourse shall do so against such party providing such
						advice,
						products or services. However, MTASB requires all Users to comply with all relevant laws, as well as the rules
						set
						out in the Website , and ensure that the law and the rules are observed and complied with. Without limitation,
						User
						acknowledges that MTASB is not responsible for the privacy and confidentiality of any personal information
						provided
						by the User to the other linked websites in any manner whatsover.</p>
					<p class="content-para">8.3 MTASB reserves absolute discretion without notice to the User, to introduce changes to
						the features appearing in
						the Website from time to time without limitation to add, modify or remove such features.</p>
					<p class="content-para">8.4 In amplification to any provisions of these Terms, MTASB does not guarantee storage of
						any data stored by the User
						in the e-remit system and excludes all liability for lost of data.</p>
					<p class="content-para">9. INDEMNITY</p>
					<p class="content-para">User shall indemnify MTASB, its directors, officers, its suppliers, their employees,
						subsidiaries, related corporation,
						associates, distributors and affiliates against any and all Loss suffered by MTASB its’ directors, officers, its
						suppliers,
						their employees, subsidiaries, related corporation, associates, distributors and affiliates to any person as a
						result
						of any breach of these Terms.</p>
					<p class="content-para">10. NOTICES</p>
					<p class="content-para">All notices are deemed served on the User immediately after it is posted on the Website or
						sent to the User’s designated
						e-mail address (despite evidence to the contrary) as set out in the Registration Form or such e-mail address of
						which
						notice has been given to MTASB by the User in writing by way of prepaid registered post.</p>
					<p class="content-para">11. FORCE MAJEURE</p>
					<p class="content-para">MTASB shall not be responsible to the User for any delay in performance or non-performance
						due to causes beyond the
						control of MTASB (including but not limited to Acts of God, devaluation of major currencies, Governmental
						mandates
						or Laws).</p>
					<p class="content-para">12. FORCE MAJEURE</p>
					<p class="content-para">This Agreement is not assignable by the User.</p>
					<p class="content-para">13. THIRD PARTY</p>
					<p class="content-para">Nothing in these Terms confers or shall purport to confer on any third party any benefit
						or any right to enforce any
						term herein.</p>
					<p class="content-para">14. JURISDICTION , GOVERNING LAW FOR LEGAL PROCEEDINGS</p>
					<p class="content-para">14.1 These Terms are governed by, and construed in accordance with, the laws of Malaysia.</p>
					<p class="content-para">14.2 If any legal proceeding arising out of or connected with the use of the Services is
						instituted by MTASB , the User
						agree that the process by which such proceedings are begun and other court documents which require service shall
						be
						deemed to have been given if served on the User and/or personally or sent to him by prepaid ordinary post
						accompanied
						by a Certificate of Posting or left at the address stated in the his Registration Form(s) or at his usual or last
						known
						business or private address. Any such Writ of Summons or originating process sent by post shall be conclusively
						deemed
						to have been received by the User within three (3) days after the date of such posting despite evidence to the
						contrary.
						The User further agrees that MTASB may at its own absolute discretion institute such legal proceedings in
						Malaysia
						or in any other place whose courts have the jurisdiction to hear and determine any such legal proceedings.</p>
					<p class="content-para">14.3 These Terms between MTASB and the User shall be deemed to have been made and executed
						at MTASB office in Petaling
						Jaya and any breach of the terms and conditions stated herein shall be deemed to have arisen in Petaling Jaya
						irrespective
						of where the User may reside or where the Transaction may have taken place.</p>
					<p class="content-para">15. DISCLOSURE</p>
					<p class="content-para">15.1 The User hereby authorise MTASB to verify and exchange information on him/her and
						his/her beneficiary (ies) from
						whatever sources as may be required and to release such information as may be obtained without reference to the
						User.</p>
					<p class="content-para">15.2 In amplification and not in derogation to Clause 15.1 above of these Terms, MTASB
						reserves the right to disclose
						part or all information concerning the User and his/her beneficiary (ies) at such time and in such manner as is
						permitted
						or required by law to the relevant authorities.</p>
					<p class="content-para">16. TIME & NON-WAIVER</p>
					<p class="content-para">Time wherever mentioned shall be the essence of these Terms and no failure to exercise and
						delay in exercising on the
						part of MTASB of any right, power or privilege under these Terms shall operate as a waiver thereof, nor shall any
						single
						or partial exercise of any right, power or privilege preclude any other or further exercise thereof or the
						exercise
						of any other right, power or privilege. The rights and remedies herein provided are cumulative and not exclusive
						of
						any rights or remedies provided by law.</p>

					<p class="content-para">17. EXCHANGE RATE</p>
					<p class="content-para">The conversion exchange rate from Ringgit Malaysia to the Recipient country’s local
						currency is subject to change without
						prior notice. The conversion exchange rate applicable to the User shall be the exchange rate displayed in the
						e-remit
						system at the time the User confirms his/her transaction in the e-remit system.</p>

					<p class="content-para">18. SEVERALIBILITY</p>
					<p class="content-para">If any provision in these Terms is found or held to be invalid or unenforceable, then the
						meaning of such provision
						shall be construed to the fullest extent allowed by law so as to under the provision valid and enforceable, and
						if
						no such construction is possible, the invalidity or unenforceability of such provision shall not affect the other
						provisions
						of these Terms.</p>

					<p class="content-para">19. AMENDMENTS</p>
					<p class="content-para">MTASB reserves the right to vary, alter and amend any or all of these Terms herein and
						announce changes to its Services
						and to post them on
						<a href="www.eremit.com.my">www.eremit.com.my</a>. User’s continued use of the Services offered by MTASB after
						such variation, alteration and amendments
						have been posted constitutes User’s agreement to be bound by them.</p>

					<p class="content-para">20. ENGLISH VERSION</p>
					<p class="content-para">In the event these Terms are translated into a language other than English, it is done
						solely for convenience purpose,
						with only the English version of these Terms shall be valid and binding.</p>

					<p class="content-para">21. DISCREPANCY AND CONFLICT</p>
					<p class="content-para">
						In the event there is conflict or discrepancy between any of the provisions of these Terms and such other terms
						appearing
						elsewhere in the Website , these Terms to the extent of such discrepancy and/or conflict shall take priority and
						precedence
						for all intents and purposes.
					</p>

					<p class="content-para">22. SURVIVAL</p>
					<p class="content-para">
						The obligations and responsibilities of the User under these Terms that, by their nature, should survive the
						termination
						of these Terms shall so survive.
					</p>

					<p class="content-para">23. TITLE AND HEADINGS</p>
					<p class="content-para">
						The titles and headings of clauses of these Terms are solely for convenience of reference and will not be used in
						interpreting
						or construing these Terms.
					</p> -->
				</div>
			</div>
		</div>


		<div class="divider"></div>
	</div>
</template>
<script>
	import DownloadApp from "../../shared/commercial/DownloadApp.vue";
	import NavHeader from "../../shared/commercial/NavHeader.vue";
	import PrivacySidebar from "../../components/privacysidebar.vue"
	import SignUpFooter from "../../shared/commercial/SignUpFooter.vue";



	export default {
		name: "Dashboard",

		components: {
			DownloadApp,
			NavHeader,
			SignUpFooter,
			PrivacySidebar
		},


		created() {},
		data() {
			return {
				ExchangeRateCollection: [],
				RecentTransactionCollection: [],
				NotificationCollection: [],

				RecipientCollection: null,
				ClassBadge: {
					'badge-yellow': true
				},
				itemTemplate: '<div class="m-b-sm m-t-sm">#:data.Fullname# <br/><img style="width:24px;" src="static/img/flags/#:data.FlagCode#.png" />#:data.CountyName#<br/> #:data.PayoutMode#</div>',
				vModel: {
					RecipientId: null
				}
			};
		},
		methods: {

			badgeColor: function (statusid) {

				var color = {
					'badge-yellow': true
				}

				switch (statusid) {
					case 1:
					case 2:
					case 3:
					case 4:
					case 6:
					case 7:
					case 8:
					case 14:
					case 15:
						color = {
							'badge-yellow': true
						}
						break;
					case 5:
						color = {
							'badge-green': true
						}
						break;
					case 9:
					case 11:
					case 12:
					case 19:
					case 20:
					case 21:
						color = {
							'badge-red': true
						}
						break;

					case 10:
					case 13:
						color = {
							'badge-grey': true
						}
						break;
				}

				return color;

			},
			sendMoney: function (e) {
				window.Vue.$router.push(e.sender._old);
			},
			pullpromotion: function () {

			}
		}
	};
</script>